import { useEffect, useRef, useState } from "react";
import { FaCheck } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AvisoVazio from "../components/AvisoVazio/AvisoVazio";
import BotaoAdicionar from "../components/BotaoAdicionar/BotaoAdicionar";
import CadastrarSistemaModal from "../components/CadastrarSistemaModal/CadastrarSistemaModal";
import Carregamento from "../components/Carregamento/Carregamento";
import DropdownPadrao from "../components/DropdownPadrao/DropdownPadrao";
import FormularioPadrao from "../components/FormularioPadrao/FormularioPadrao";
import FormularioPadraoExpansivo from "../components/FormularioPadraoExpansivo/FormularioPadraoExpansivo";
import InputPadrao from "../components/InputPadrao/InputPadrao";
import ListagemInfoLicenca from "../components/ListagemInfoLicenca/ListagemInfoLicenca";
import ListaSistemasModal from "../components/ListaSistemasModal/ListaSistemasModal";
import { EnumSistemas } from "../utils/EnumsUtils";
import ModalSistemas from "../components/ModalSistemas/ModalSistemas";
import TogglePadrao from "../components/TogglePadrao/TogglePadrao";
import { useEmpresa, usePlano } from "../hooks/DropdownHooks";
import api from "../services/api";
import { APP_ROUTES } from "../services/app_routes";
import FormatacaoUtils, { TipoFormatacao } from "../utils/FormatacaoUtils";
import Mensagens from "../utils/MensagemUtils";
import NotificacaoUtils from "../utils/NotificacaoUtils";
import { isSuperAdmin } from "../utils/PermissaoUtils";
import { TipoValidacao, ValidacaoUtils } from "../utils/ValidacaoUtils";
import './Cadastros.css';

// Mapeamento de idTipoSistema para nome utilizado em EnumSistemas
const idToSistema = {
  1: EnumSistemas.DIXI_PONTO,
  2: EnumSistemas.DIXI_ACESSOS,
  3: EnumSistemas.DIXI_CHAMADOS,
};

const getSistemaNome = licenca =>
  idToSistema[licenca.planoDTO?.idTipoSistema] ||
  licenca.planoDTO?.descricaoTipoSistema ||
  "";

const situacaoAtiva = valor =>
  valor === true ||
  valor === 'ATIVO' ||
  valor === 'Ativo' ||
  (typeof valor === 'string' && valor.toUpperCase() === 'ATIVO');

const CadastroCliente = ({ isEdit = false }) => {
    const { id } = useParams(); // Pega o ID da URL
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const licencaId = params.get("licencaId");
    const navigate = useNavigate();
    const [carregando, setCarregando] = useState(false);
    const [dadosClienteCarregados, setDadosClienteCarregados] = useState(false);
    const [errors, setErrors] = useState({});
    const { itens: empresa, carregando: carregandoEmpresa } = useEmpresa();
    const { itens: plano, carregando: carregandoPlano } = usePlano();

    const [mostrarModalSistemas, setMostrarModalSistemas] = useState(false);
    const [etapaModal, setEtapaModal] = useState("listar"); 
    const [sistemaSelecionado, setSistemaSelecionado] = useState(null);
    const [alturaEtapa, setAlturaEtapa] = useState(2);
    const [sistemas, setSistemas] = useState([]);
    const [sistemasOriginais, setSistemasOriginais] = useState([]); // Para rastrear os sistemas originais
    const [sistemasModificados, setSistemasModificados] = useState([]); // Para rastrear os sistemas modificados
    const [licencaEditando, setLicencaEditando] = useState(null); 
    const [clienteJaCadastrado, setClienteJaCadastrado] = useState(false);
    const [idClienteSalvo, setIdClienteSalvo] = useState(null);

    const clienteInicial = {
      idCliente: 0,
      razaoSocial: '',
      documento: '',
      email: '',
      telefone: '',
      empresa: '',
      situacaoCadastro: true,
      dataCriacao: '',
      dataAlteracao: '',
      nomeFantasia: '',
      cep: '',
      cidade: '',
      endereco: '',
      numero: '',
      estado: '',
      bairro: '',
    };

    const [clienteOriginal, setClienteOriginal] = useState(clienteInicial);

    let modalTitulo = Mensagens.CLIENTE.LICENCA.ADICIONAR_LICENCA;
    if (etapaModal !== 'listar' && sistemaSelecionado) {
      modalTitulo = isEdit
        ? `Licença - ${sistemaSelecionado.nome}`
        : Mensagens.CLIENTE.LICENCA.ADICIONAR_LICENCA_COM_NOME.replace('{nome}', sistemaSelecionado.nome);
    }

    const carregamentoGeral = () => {
      return carregando || carregandoEmpresa || carregandoPlano;
    };    
    
    const [cliente, setCliente] = useState(clienteInicial);
    
    const buscarCliente = async (idCliente) => {
      setCarregando(true);
      try {
        const apiResponse = await api.get(`/cliente_/geral/${idCliente}`);

        if (apiResponse.success && apiResponse.data) {
          
          const { clienteDTO, sistemas } = apiResponse.data;
          
          // Normaliza situacaoCadastro para booleano (case-insensitive)
          const situacaoAtiva = clienteDTO.situacaoCadastro === true || 
                                (typeof clienteDTO.situacaoCadastro === 'string' && 
                                 clienteDTO.situacaoCadastro.toUpperCase() === "ATIVO");
          
          setCliente({
            ...clienteInicial,
            idCliente: clienteDTO.id || 0,
            razaoSocial: clienteDTO.razaoSocial || '',
            documento: clienteDTO.documento || '',
            email: clienteDTO.email || '',
            telefone: clienteDTO.telefone || '',
            empresa: String(clienteDTO.empresaDTO?.id) || '',
            situacaoCadastro: situacaoAtiva,
            dataCriacao: clienteDTO.dataCriacao || '',
            dataAlteracao: clienteDTO.dataAlteracao || '',
            nomeFantasia: clienteDTO.nomeFantasia || '',
            cep: clienteDTO.cep || '',
            cidade: clienteDTO.cidade || '',
            endereco: clienteDTO.endereco || '',
            numero: clienteDTO.numero || '',
            estado: clienteDTO.estado || '',
            bairro: clienteDTO.bairro || '',
          });

          // Garante que cada sistema tenha um id único para edição e normaliza valores
          const sistemasComId = Array.isArray(sistemas) 
            ? sistemas.map((s, idx) => {
                console.log('Sistema da API ID:', s.id, 'situacaoCadastro:', s.situacaoCadastro, 'tipo:', typeof s.situacaoCadastro);
                
                // Normaliza situacaoCadastro para booleano (case-insensitive)
                const situacaoBooleana = s.situacaoCadastro === true || 
                                        (typeof s.situacaoCadastro === 'string' && 
                                         s.situacaoCadastro.toUpperCase() === "ATIVO");
                
                console.log('Convertido para:', situacaoBooleana);
                
                return {
                  ...s,
                  id: s.id || idx,
                  situacaoCadastro: situacaoBooleana
                };
              }) 
            : [];
          
          // Salva os sistemas originais e inicializa os sistemas modificados como vazio
          setSistemas(sistemasComId);
          setSistemasOriginais(JSON.parse(JSON.stringify(sistemasComId))); // Cria uma cópia profunda
          setSistemasModificados([]);
          
          setDadosClienteCarregados(true);
        } else {
          NotificacaoUtils.erro(Mensagens.CLIENTE.ERRO.CARREGAR);
          navigate(APP_ROUTES.CLIENTE_VISUALIZAR);
        }
      } catch (error) {
        console.error("Erro ao carregar cliente:", error);
        NotificacaoUtils.erro(Mensagens.CLIENTE.ERRO.CARREGAR);
        navigate(APP_ROUTES.CLIENTE_VISUALIZAR);
      } finally {
        setCarregando(false);
      }
    };
    
    useEffect(() => {
      if (isEdit && id && !dadosClienteCarregados) {
        buscarCliente(id);
      }
    }, [isEdit, id, dadosClienteCarregados]);
    
    // Salva o cliente original para comparação
    useEffect(() => {
      if (dadosClienteCarregados) {
        setClienteOriginal(cliente);
      }
    }, [dadosClienteCarregados]);

    function clienteFoiAlterado() {
      // Compara os campos relevantes do cliente atual com o original
      const campos = [
        'razaoSocial', 'nomeFantasia', 'documento', 'endereco', 'numero', 'cep',
        'cidade', 'bairro', 'estado', 'telefone', 'email', 'situacaoCadastro', 'empresa'
      ];
      return campos.some(campo => cliente[campo] !== clienteOriginal[campo]);
    }

    const ignoreLicencaIdEffect = useRef(false);

    useEffect(() => {
      if (
        licencaId &&
        sistemas.length > 0 &&
        !mostrarModalSistemas &&
        isEdit &&
        dadosClienteCarregados &&
        !ignoreLicencaIdEffect.current
      ) {
        const licenca = sistemas.find(l => String(l.id) === String(licencaId));
        if (licenca) {
          // Usa mapeamento para selecionar sistema correto
          setSistemaSelecionado({ nome: getSistemaNome(licenca) });
          setLicencaEditando(licenca);
          setEtapaModal("cadastrar");
          setMostrarModalSistemas(true);
          setAlturaEtapa(2);
        }
      }
      // Sempre reseta após o efeito rodar
      ignoreLicencaIdEffect.current = false;
    }, [licencaId, sistemas, mostrarModalSistemas, isEdit, dadosClienteCarregados]);
    
    const handleInputChange = (e, field) => {
      setCliente({
        ...cliente,
        [field]: e.target.value,
      });

      if (field === 'documento' && errors.cnpj) {
        setErrors({
          ...errors,
          cnpj: null,
        });
      } else if (errors[field]) {
        setErrors({
          ...errors,
          [field]: null,
        });
      }
    };

    const handleSwitchChange = (novoValor, field) => {
      setCliente({
        ...cliente,
        [field]: novoValor,
      });

      if (field === 'situacaoCadastro' && novoValor === false) {
        setSistemas(prev => {
          const sistemasInativados = prev.map(sistema => ({
            ...sistema,
            situacaoCadastro: false,
          }));

          if (isEdit) {
            setSistemasModificados(modificados => {
              const modificadosPorId = new Map(modificados.map(sistema => [sistema.id, sistema]));
              sistemasInativados
                .filter(sistema => sistema.id && sistema.id !== 0)
                .forEach(sistema => modificadosPorId.set(sistema.id, sistema));
              return Array.from(modificadosPorId.values());
            });
          }

          return sistemasInativados;
        });
      }
    };

    const validarFormulario = () => {
      const retornoValidacao = ValidacaoUtils.validateForm(
        cliente,
        TipoValidacao.CLIENTE_CRIAR
      );

      if (!retornoValidacao.success) {
        setErrors(retornoValidacao.errors);
        return false;
      }

      return true;
    };

    // Helper to get tipoLimiteIds
    const tipoLimiteIds = {
      usuario: 1,
      usuarios: 1, // Adiciona plural
      equipamento: 2,
      equipamentos: 2, // Adiciona plural
      pessoa: 3,
      pessoas: 3, // Adiciona plural
      funcionario: 4,
      funcionarios: 4, // Adiciona plural
      mobile: 5,
      mobiles: 5, // Adiciona plural
    };

    function getIdTipoLimite(descricao) {
      if (!descricao) return null;
      
      // Normaliza removendo acentos, tornando minúsculo e removendo caracteres especiais
      const desc = descricao
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Remove acentos
        .toLowerCase()
        .replace(/[^\w]/g, ''); // Remove caracteres especiais
      
      // Tenta com a descrição normalizada
      if (tipoLimiteIds[desc]) {
        return tipoLimiteIds[desc];
      }
      
      // Tenta versão singular (remove s final se existir)
      const singular = desc.endsWith('s') ? desc.slice(0, -1) : desc;
      if (tipoLimiteIds[singular]) {
        return tipoLimiteIds[singular];
      }
      
      
      // Mapeamento de fallback baseado em palavras-chave
      if (desc.includes('usuario') || desc.includes('user')) return 1;
      if (desc.includes('equip')) return 2;
      if (desc.includes('pessoa')) return 3;
      if (desc.includes('func')) return 4;
      if (desc.includes('mob')) return 5;
      
      return null;
    }

    function montarPayload(licencas, idClienteSalvo) {
      const payload = licencas.map(licenca => ({
        idSistema: licenca.id || 0,
        plano: {
          idPlano: licenca.planoDTO?.id || 0,
          tipoSistema: {
            idTipoSistema: licenca.planoDTO?.idTipoSistema,
          },
          descricao: licenca.planoDTO?.descricao,
        },
        cliente: { idCliente: idClienteSalvo },
        funcionalidadeAdicional: licenca.funcionalidadeAdicional || false,
        descricao: licenca.planoDTO?.descricao || '',
        // Cliente inativo força licença inativa; cliente ativo respeita a situação escolhida na licença.
        situacaoCadastro: cliente.situacaoCadastro && situacaoAtiva(licenca.situacaoCadastro) ? 'ATIVO' : 'INATIVO',
        // Enviamos o valor como booleano true/false
        acessoSuporte: licenca.acessoSuporte === true,
        unidade: licenca.unidade || '',
        numeroPedido: licenca.numeroPedido || '',
        dataExpiracao: FormatacaoUtils.formatarDataParaYYYYMMDD(licenca.dataExpiracao) || '',
        dataCancelamento: FormatacaoUtils.formatarDataParaYYYYMMDD(licenca.dataCancelamento) || null,
        limitesParaCadastroEdicao: Array.isArray(licenca.limites)
          ? licenca.limites.map(limite => ({
              idSistema: null,
              // Usar o idTipoLimite já armazenado, se disponível, ou tentar obter da descrição
              idTipoLimite: limite.idTipoLimite || getIdTipoLimite(limite.descricao),
              max: limite.max,
              utilizado: limite.utilizado || 0,
            }))
          : [],
        // Adiciona os IDs de funcionalidades para vincular/remover
        idsFuncionalidadesAdicionar: licenca.funcionalidadesVinculo?.idsFuncionalidadesAdicionar || [],
        idsFuncionalidadesRemover: licenca.funcionalidadesVinculo?.idsFuncionalidadesRemover || [],
      }));
      
      console.log('=== PAYLOAD MONTADO ===');
      console.log(JSON.stringify(payload, null, 2));
      console.log('=======================');
      
      return payload;
    }

    function limparPayload(arr) {
      arr.forEach(sistema => {
        Object.keys(sistema).forEach(key => sistema[key] === undefined && delete sistema[key]);
      });
    }

    async function salvarSistemasNovos(sistemasNovos, idClienteSalvo) {
      if (sistemasNovos.length === 0) return { success: true };
      const payloadNovos = montarPayload(sistemasNovos, idClienteSalvo);
      limparPayload(payloadNovos);
      const resposta = await Promise.resolve(api.post('/sistema_', payloadNovos));
      
      // Após criar o sistema, salva os vínculos de funcionalidades se houver
      if (resposta.success && resposta.data) {
        await salvarVinculosFuncionalidades(sistemasNovos, resposta.data);
      }
      
      return resposta;
    }

    async function salvarSistemasExistentes(sistemasExistentes, idClienteSalvo) {
      if (sistemasExistentes.length === 0) return { success: true };
      const payloadExistentes = montarPayload(sistemasExistentes, idClienteSalvo);
      limparPayload(payloadExistentes);
      const resposta = await Promise.resolve(api.put('/sistema_', payloadExistentes));
      
      // Após atualizar o sistema, salva os vínculos de funcionalidades se houver
      if (resposta.success) {
        await salvarVinculosFuncionalidades(sistemasExistentes);
      }
      
      return resposta;
    }

    async function salvarVinculosFuncionalidades(sistemas, sistemasRetornados = null) {
      console.log('=== INICIANDO SALVAMENTO DE VÍNCULOS ===');
      console.log('Sistemas recebidos:', sistemas);
      console.log('Sistemas retornados da API:', sistemasRetornados);
      
      for (let i = 0; i < sistemas.length; i++) {
        const sistema = sistemas[i];
        console.log(`\n--- Sistema ${i + 1} ---`);
        console.log('Sistema completo:', sistema);
        
        const funcionalidades = sistema.funcionalidadesVinculo;
        console.log('Funcionalidades vinculo:', funcionalidades);
        
        // Verifica se há funcionalidades para vincular ou remover
        if (!funcionalidades) {
          console.log('Nenhum objeto funcionalidadesVinculo encontrado');
          continue;
        }
        
        if (funcionalidades.idsFuncionalidadesAdicionar.length === 0 && 
            funcionalidades.idsFuncionalidadesRemover.length === 0) {
          console.log('Nenhuma funcionalidade para adicionar ou remover');
          continue;
        }
        
        // Para sistemas novos, pega o ID do retorno da API
        let idSistema = sistema.id;
        console.log('ID inicial do sistema:', idSistema);
        
        if (sistemasRetornados && Array.isArray(sistemasRetornados)) {
          const sistemaRetornado = sistemasRetornados[i];
          console.log('Sistema retornado correspondente:', sistemaRetornado);
          idSistema = sistemaRetornado?.idSistema || sistemaRetornado?.id;
          console.log('ID extraído do retorno:', idSistema);
        }
        
        if (!idSistema) {
          console.error('ID do sistema não encontrado para vincular funcionalidades');
          continue;
        }
        
        const payload = {
          idSistema: idSistema,
          idsFuncionalidadesAdicionar: funcionalidades.idsFuncionalidadesAdicionar,
          idsFuncionalidadesRemover: funcionalidades.idsFuncionalidadesRemover
        };
        
        console.log('Payload que será enviado:', JSON.stringify(payload, null, 2));
        
        try {
          console.log('Enviando requisição para /funcionalidadeAdicional_/vinculos');
          const resposta = await api.post('/funcionalidadeAdicional_/vinculos', payload);
          console.log('Resposta recebida:', resposta);
          
          if (!resposta.success) {
            console.error('Erro ao vincular funcionalidades:', resposta.message);
          } else {
            console.log('Funcionalidades vinculadas com sucesso!');
          }
        } catch (erro) {
          console.error('Erro ao vincular funcionalidades:', erro);
        }
      }
      
      console.log('=== FIM DO SALVAMENTO DE VÍNCULOS ===');
    }

    const handleCadastro = async () => {
      if (!validarFormulario()) return false;
      setCarregando(true);
      try {
        let idClienteParaUsar = idClienteSalvo;
        let clienteResponse = { success: true };
        
        // Só cadastra o cliente se não estiver cadastrado ou se houve alteração
        if (!clienteJaCadastrado || (isEdit && clienteFoiAlterado())) {
          const dadosCliente = {
            idCliente: isEdit ? cliente.idCliente : 0,
            razaoSocial: cliente.razaoSocial,
            nomeFantasia: cliente.nomeFantasia,
            documento: cliente.documento,
            endereco: cliente.endereco,
            numero: cliente.numero,
            cep: cliente.cep,
            cidade: cliente.cidade,
            bairro: cliente.bairro,
            estado: cliente.estado,
            telefone: cliente.telefone,
            email: cliente.email,
            situacaoCadastro: cliente.situacaoCadastro ? 'ATIVO' : 'INATIVO',
            empresa: { idEmpresa: cliente.empresa },
          };
          clienteResponse = isEdit
            ? await Promise.resolve(api.put(`/cliente_`, dadosCliente))
            : await Promise.resolve(api.post(`/cliente_`, dadosCliente));
          if (!clienteResponse.success) {
            NotificacaoUtils.erro(clienteResponse.message || Mensagens.CLIENTE.ERRO.ATUALIZAR);
            setCarregando(false);
            return;
          }
          idClienteParaUsar = isEdit ? cliente.idCliente : clienteResponse.data?.idCliente;
          setIdClienteSalvo(idClienteParaUsar);
          setClienteJaCadastrado(true);
          setClienteOriginal(cliente); // Atualiza o original após sucesso
        }

        // Cadastro de sistemas/licenças
        if (sistemas.length > 0) {
          // Se for edição, usamos os sistemas modificados
          const sistemasParaSalvar = isEdit ? sistemasModificados : sistemas;
          
          if (sistemasParaSalvar.length > 0) {
            const sistemasNovos = sistemasParaSalvar.filter(licenca => !licenca.id || licenca.id === 0);
            const sistemasExistentes = sistemasParaSalvar.filter(licenca => licenca.id && licenca.id !== 0);
            
            if (sistemasNovos.length > 0) {
              let responseLicenca = await salvarSistemasNovos(sistemasNovos, idClienteParaUsar);
              if (!responseLicenca.success) {
                NotificacaoUtils.erro(responseLicenca.message || Mensagens.CLIENTE.ERRO.ATUALIZAR);
                // Marca que o cliente já foi cadastrado, para tentar só as licenças depois
                setClienteJaCadastrado(true);
                setIdClienteSalvo(idClienteParaUsar);
                setCarregando(false);
                return;
              }
            }
            
            if (sistemasExistentes.length > 0) {
              let responseLicenca = await salvarSistemasExistentes(sistemasExistentes, idClienteParaUsar);
              if (!responseLicenca.success) {
                NotificacaoUtils.erro(responseLicenca.message || Mensagens.CLIENTE.ERRO.ATUALIZAR);
                setClienteJaCadastrado(true);
                setIdClienteSalvo(idClienteParaUsar);
                setCarregando(false);
                return;
              }
            }
            
            // Após salvar com sucesso, recarrega os dados da API para sincronizar
            if (isEdit) {
              await buscarCliente(idClienteParaUsar);
            }
          }
        }
        NotificacaoUtils.sucesso(isEdit ? Mensagens.CLIENTE.ATUALIZADO_SUCESSO : Mensagens.CLIENTE.CADASTRADO_SUCESSO);
        // navegação será tratada no onSalvar
        return true;
      } catch (error) {
        console.error("Erro ao salvar cliente ou sistemas:", error);
        NotificacaoUtils.erro(Mensagens.CLIENTE.ERRO.ATUALIZAR_TENTE_NOVAMENTE);
        return false;
      } finally {
        setCarregando(false);
      }
    };

    const handleCancel = () => {
      navigate(APP_ROUTES.CLIENTE_VISUALIZAR);
    };

    function mapLimitesArrayToObj(limitesArray) {
      if (!Array.isArray(limitesArray)) return {};
      const obj = {};
      
      // Mapeamento de descrições para chaves específicas que o componente espera
      const mapeamentoDescricaoParaChave = {
        'mobile': 'mobile',
        'equipamento': 'equipamentos', // Mapeia singular para plural
        'equipamentos': 'equipamentos', // Mapeia plural para plural
        'funcionário': 'funcionarios',
        'funcionario': 'funcionarios',
        'funcionários': 'funcionarios',
        'funcionarios': 'funcionarios',
        'usuário': 'usuarios',
        'usuario': 'usuarios',
        'usuários': 'usuarios',
        'usuarios': 'usuarios',
        'pessoas': 'pessoas',
        'pessoa': 'pessoas'
      };
      
      limitesArray.forEach(limite => {
        if (!limite.descricao) return;
        
        // Normaliza a descrição para facilitar a comparação
        const descricaoNormalizada = limite.descricao.normalize('NFD')
          .replace(/[^\w]/g, '')
          .toLowerCase();
        
        // Tenta encontrar uma correspondência exata primeiro
        let chaveEncontrada = mapeamentoDescricaoParaChave[descricaoNormalizada];
        
        // Se não encontrar correspondência exata, tenta encontrar uma correspondência parcial
        if (!chaveEncontrada) {
          for (const [descricao, chave] of Object.entries(mapeamentoDescricaoParaChave)) {
            if (descricaoNormalizada.includes(descricao)) {
              chaveEncontrada = chave;
              break;
            }
          }
        }
        
        // Mapeamento adicional específico para equipamentos (para casos onde a API retorna variações)
        if (!chaveEncontrada && (descricaoNormalizada.includes('equip') || descricaoNormalizada.includes('equipment'))) {
          chaveEncontrada = 'equipamentos';
        }
        
        // Se encontrou uma chave, usa ela, senão usa a descrição normalizada
        const chaveParaUsar = chaveEncontrada || descricaoNormalizada;
        obj[chaveParaUsar] = limite.max;
      });
      
      return obj;
    }

    // Função para criar uma nova licença
    function criarNovaLicenca(dados, sistemaSelecionado) {
      const novaLicenca = {
        id: 0,
        planoDTO: {
          id: dados.plano.id,
          descricaoTipoSistema: sistemaSelecionado.nome,
          descricao: dados.plano.descricao,
          idTipoSistema: dados.plano.idTipoSistema,
        },
        unidade: dados.unidadeNegocio,
        numeroPedido: dados.numeroPedido,
        limites: Object.entries(dados.limites || {}).map(([key, value]) => {
          const idTipo = tipoLimiteIds[key.toLowerCase()] || null;
          return {
            id: 0,
            descricao: key.charAt(0).toUpperCase() + key.slice(1),
            utilizado: 0,
            max: value,
            idTipoLimite: idTipo // Adicionando o ID do tipo de limite diretamente aqui
          };
        }),
        dataInclusao: new Date().toLocaleDateString('pt-BR'),
        dataExpiracao: dados.expiracao,
        situacaoCadastro: cliente.situacaoCadastro && situacaoAtiva(dados.situacao) ? 'ATIVO' : 'INATIVO',
        cancelado: false,
        expirado: false,
        // Em objetos do frontend, garantimos que seja booleano
        acessoSuporte: dados.acessoSuporte === true,
        // Adiciona as funcionalidades para vincular/remover
        funcionalidadesVinculo: dados.funcionalidadesVinculo || {
          idsFuncionalidadesAdicionar: [],
          idsFuncionalidadesRemover: [],
          funcionalidadesSelecionadas: []
        }
      };
      
      return novaLicenca;
    }

    // Função para atualizar uma licença existente
    function atualizarLicencaEditada(licencaEditando, dados, sistemaSelecionado) {
      const sistemaAtualizado = {
        ...licencaEditando,
        planoDTO: {
          id: dados.plano.id,
          descricaoTipoSistema: sistemaSelecionado.nome,
          descricao: dados.plano.descricao,
          idTipoSistema: dados.plano.idTipoSistema,
        },
        unidade: dados.unidadeNegocio,
        numeroPedido: dados.numeroPedido,
        limites: Object.entries(dados.limites || {}).map(
          ([key, value]) => {
            const idTipo = tipoLimiteIds[key.toLowerCase()] || null;
            return {
              id: licencaEditando.limites?.find(l => l.descricao && l.descricao.toLowerCase().includes(key.toLowerCase()))?.id || 0,
              descricao: key.charAt(0).toUpperCase() + key.slice(1),
              utilizado: 0,
              max: value,
              idTipoLimite: idTipo // Adicionando o ID do tipo de limite diretamente aqui
            };
          }
        ),
        dataExpiracao: dados.expiracao,
        dataCancelamento: dados.cancelamento, // Garante atualização do campo cancelamento
        situacaoCadastro: cliente.situacaoCadastro ? dados.situacao : false,
        // Em objetos do frontend, garantimos que seja booleano
        acessoSuporte: dados.acessoSuporte === true,
        // Adiciona as funcionalidades para vincular/remover
        funcionalidadesVinculo: dados.funcionalidadesVinculo || {
          idsFuncionalidadesAdicionar: [],
          idsFuncionalidadesRemover: [],
          funcionalidadesSelecionadas: []
        }
      };
      
      return sistemaAtualizado;
    }

    return (
      <div>
        {carregamentoGeral() && <Carregamento />}

        <FormularioPadrao
          titulo={isEdit ? Mensagens.CLIENTE.EDICAO_TITULO : Mensagens.CLIENTE.CADASTRO_TITULO}
          subtitulo={
            isEdit ? Mensagens.CLIENTE.EDICAO_SUBTITULO : Mensagens.CLIENTE.CADASTRO_SUBTITULO
          }
          tituloInterno={Mensagens.INFORMACOES_GERAIS}
          onSalvar={async () => {
            const sucesso = await handleCadastro();
            if (sucesso) {
                navigate(APP_ROUTES.CLIENTE_VISUALIZAR);
            }
          }}
          onCancelar={handleCancel}
          iconeBotao={<FaCheck />}
          dataCriacao={isEdit ? cliente.dataCriacao : null}
          dataAlteracao={isEdit ? cliente.dataAlteracao : null}
          inferiorChildren={
            <>
              <FormularioPadraoExpansivo
                tituloCard={Mensagens.CLIENTE.INFORMACOES_ADICIONAIS}
                tituloInterno={Mensagens.CLIENTE.SUBTITULO_INFORMACOES_ADICIONAIS}
              >
                <div className="inputs-flex">
                  <div className="linha-flex">
                    <InputPadrao
                      label={Mensagens.CLIENTE.NOME_FANTASIA}
                      placeholder={Mensagens.CLIENTE.NOME_FANTASIA_PLACEHOLDER}
                      required={false}
                      value={cliente.nomeFantasia}
                      erroMensagem={errors.nomeFantasia}
                      onChange={e => handleInputChange(e, 'nomeFantasia')}
                    />
                    <InputPadrao
                      label={Mensagens.CLIENTE.CEP}
                      placeholder={Mensagens.CLIENTE.CEP_PLACEHOLDER}
                      required={false}
                      value={cliente.cep}
                      erroMensagem={errors.cep}
                      onChange={e => handleInputChange(e, 'cep')}
                    />
                  </div>

                  <div className="linha-flex">
                    <InputPadrao
                      label={Mensagens.CLIENTE.CIDADE}
                      placeholder={Mensagens.CLIENTE.CIDADE_PLACEHOLDER}
                      required={false}
                      value={cliente.cidade}
                      onChange={e => handleInputChange(e, 'cidade')}
                    />

                    <div className="input-grupo">
                      <InputPadrao
                        label={Mensagens.CLIENTE.ENDERECO}
                        placeholder={Mensagens.CLIENTE.ENDERECO_PLACEHOLDER}
                        required={false}
                        value={cliente.endereco}
                        onChange={e => handleInputChange(e, 'endereco')}
                        ladoSemBorderRadius={InputPadrao.Lados.DIREITA}
                      />
                      <InputPadrao
                        label={Mensagens.CLIENTE.NUMERO}
                        placeholder={Mensagens.CLIENTE.NUMERO_PLACEHOLDER}
                        required={false}
                        value={cliente.numero}
                        onChange={e => handleInputChange(e, 'numero')}
                        ladoSemBorderRadius={InputPadrao.Lados.ESQUERDA}
                        ladoSemBorda={InputPadrao.Lados.ESQUERDA}
                      />
                    </div>
                  </div>

                  <div className="linha-flex">
                    <InputPadrao
                      label={Mensagens.CLIENTE.ESTADO}
                      placeholder={Mensagens.CLIENTE.ESTADO_PLACEHOLDER}
                      required={false}
                      value={cliente.estado}
                      onChange={e => handleInputChange(e, 'estado')}
                    />
                    <InputPadrao
                      label={Mensagens.CLIENTE.BAIRRO}
                      placeholder={Mensagens.CLIENTE.BAIRRO_PLACEHOLDER}
                      required={false}
                      value={cliente.bairro}
                      onChange={e => handleInputChange(e, 'bairro')}
                    />
                  </div>

                  <div className="linha-flex">
                    <InputPadrao
                      label={Mensagens.CLIENTE.TELEFONE}
                      placeholder={Mensagens.CLIENTE.TELEFONE_PLACEHOLDER}
                      required={false}
                      value={cliente.telefone}
                      onChange={e => handleInputChange(e, 'telefone')}
                    />
                    <InputPadrao
                      label={Mensagens.CLIENTE.EMAIL}
                      placeholder={Mensagens.CLIENTE.EMAIL_PLACEHOLDER}
                      required={false}
                      value={cliente.email}
                      onChange={e => handleInputChange(e, 'email')}
                    />
                  </div>
                </div>
              </FormularioPadraoExpansivo>
              <FormularioPadrao
                tituloInterno={
                  isEdit
                    ? Mensagens.CLIENTE.LICENCA.EDICAO_LICENCAS
                    : Mensagens.CLIENTE.LICENCA.CADASTRO_LICENCAS
                }
                componenteDireitaTitulo={
                  <BotaoAdicionar
                    aoClicar={() => {
                      setMostrarModalSistemas(true);
                      setEtapaModal('listar');
                      setAlturaEtapa(2);
                    }}
                  />
                }
              >
                {sistemas.length === 0 ? (
                  <AvisoVazio
                    titulo={Mensagens.CLIENTE.LICENCA.NENHUMA_CADASTRADA}
                    mensagem={Mensagens.CLIENTE.LICENCA.PARA_CADASTRAR}
                    mensagemDestaque={Mensagens.CLIENTE.LICENCA.ADICIONAR_LICENCA_MAIS}
                    onClickDestaque={() => {
                      setMostrarModalSistemas(true);
                      setEtapaModal('listar');
                      setAlturaEtapa(2);
                    }}
                  />
                ) : (
                  <ListagemInfoLicenca
                    informacoesLicenca={sistemas}
                    exibeCopiarUnidade={false}
                    exibeEditarPadrao={false}
                    exibeSituacao={true}
                    onClickEditar={licenca => {
                      // Mapeia sistema para abrir modal já em cadastro
                      setSistemaSelecionado({ nome: getSistemaNome(licenca) });
                      setEtapaModal('cadastrar');
                      setAlturaEtapa(2);
                      setMostrarModalSistemas(true);
                      setLicencaEditando(licenca);
                    }}
                  />
                )}
              </FormularioPadrao>
            </>
          }
        >
          <div className="inputs-flex">
            <div className="linha-flex">
              <InputPadrao
                label={Mensagens.CLIENTE.RAZAO_SOCIAL}
                placeholder={Mensagens.CLIENTE.RAZAO_SOCIAL_PLACEHOLDER}
                required={true}
                value={cliente.razaoSocial}
                erroMensagem={errors.razaoSocial}
                onChange={e => handleInputChange(e, 'razaoSocial')}
              />
              <InputPadrao
                label={Mensagens.CLIENTE.DOCUMENTO}
                placeholder={Mensagens.CLIENTE.DOCUMENTO_PLACEHOLDER}
                required={true}
                value={cliente.documento}
                tipoFormatador={TipoFormatacao.DOCUMENTO}
                type={InputPadrao.TipoInput.DOCUMENTO}
                erroMensagem={errors.cnpj}
                onChange={e => handleInputChange(e, 'documento')}
              />
            </div>
            <div className="linha-flex"></div>
            <div className="linha-flex">
              <DropdownPadrao
                label={'Empresa'}
                required={true}
                showFilter={true}
                options={empresa}
                value={cliente.empresa}
                exibirSe={isSuperAdmin()}
                erroMensagem={errors.empresa}
                onChange={e => handleInputChange(e, 'empresa')}
              />
              <TogglePadrao
                label={Mensagens.CLIENTE.SITUACAO_CADASTRO}
                value={cliente.situacaoCadastro}
                disabled={!isEdit}
                onChange={novoValor => handleSwitchChange(novoValor, 'situacaoCadastro')}
              />
            </div>
          </div>
        </FormularioPadrao>

        <ModalSistemas
          aberto={mostrarModalSistemas}
          titulo={modalTitulo}
          animacaoExpandir={etapaModal === 'cadastrar'}
          etapaModal={etapaModal}
          alturaEtapa={alturaEtapa}
          tamanhoEtapa={etapaModal === 'cadastrar' ? 45 : 20}
          onRetornar={etapaModal === 'cadastrar' && !licencaEditando ? () => setEtapaModal('listar') : undefined}
          subtitulo={
            etapaModal === 'listar'
              ? Mensagens.CLIENTE.LICENCA.SELECIONE_SISTEMA
              : Mensagens.CLIENTE.LICENCA.INSIRA_INFO_LICENCA
          }
          onClose={() => {
            ignoreLicencaIdEffect.current = true;

            // Remove licencaId da URL antes de fechar o modal
            if (licencaId) {
              const params = new URLSearchParams(location.search);
              params.delete('licencaId');
              navigate(
                { pathname: location.pathname, search: params.toString() },
                { replace: true }
              );
            }

            setMostrarModalSistemas(false);
            setEtapaModal('listar');
            setAlturaEtapa(2);
          }}
        >
          {etapaModal === 'listar' ? (
            <ListaSistemasModal
              onSelecionarSistema={sistema => {
                setSistemaSelecionado(sistema);
                setEtapaModal('cadastrar');
                setLicencaEditando(null);
              }}
            />
          ) : (
            <CadastrarSistemaModal
              sistema={sistemaSelecionado.nome}
              licencasExistentes={sistemas.filter(l => l !== licencaEditando)}
              plano={plano}
              editando={isEdit}
              valoresIniciais={
                licencaEditando
                  ? {
                      id: licencaEditando.id || licencaEditando.idSistema,
                      plano: licencaEditando.planoDTO?.descricao,
                      numeroPedido: licencaEditando.numeroPedido,
                      unidadeNegocio: licencaEditando.unidade,
                      expiracao: licencaEditando.dataExpiracao,
                      cancelamento: licencaEditando.dataCancelamento, // Passa a data de cancelamento
                      limites: mapLimitesArrayToObj(licencaEditando.limites),
                      situacao: licencaEditando.situacaoCadastro, // passa o valor original, sem conversão
                      funcionalidadesAdicionais: licencaEditando.funcionalidadesAdicionais || [],
                      // Função de conversão robusta para acessoSuporte
                      acessoSuporte: (() => {
                        const valor = licencaEditando.acessoSuporte;
                        // Para strings, verifica se contém "Sim" ou "true" (case insensitive)
                        if (typeof valor === 'string') {
                          return valor.toLowerCase() === 'sim' || valor.toLowerCase() === 'true';
                        }
                        // Para booleanos ou outros tipos, compara diretamente com true
                        return valor === true;
                      })()
                    }
                  : {}
              }
              onClickCancelar={() => {
                ignoreLicencaIdEffect.current = true;
                setMostrarModalSistemas(false);
                setEtapaModal('listar');
                setAlturaEtapa(2);
                setLicencaEditando(null);

                // Remove licencaId da URL ao cancelar
                if (licencaId) {
                  const params = new URLSearchParams(location.search);
                  params.delete('licencaId');
                  navigate(
                    { pathname: location.pathname, search: params.toString() },
                    { replace: true }
                  );
                }
              }}
              onClickFinalizar={dados => {
                ignoreLicencaIdEffect.current = true;
                if (licencaEditando) {
                  const sistemaAtualizado = atualizarLicencaEditada(licencaEditando, dados, sistemaSelecionado);
                  
                  // Atualiza a lista de sistemas
                  setSistemas(prev =>
                    prev.map(l => l.id === licencaEditando.id ? sistemaAtualizado : l)
                  );
                  
                  // Para sistemas existentes (com ID), sempre adiciona/atualiza na lista de modificados
                  if (isEdit && licencaEditando.id !== 0) {
                    // Verifica se os dados são diferentes do original
                    const sistemaOriginal = sistemasOriginais.find(s => s.id === licencaEditando.id);
                    const foiModificado = !(
                      sistemaOriginal &&
                      sistemaOriginal.planoDTO?.id === sistemaAtualizado.planoDTO?.id &&
                      sistemaOriginal.unidade === sistemaAtualizado.unidade &&
                      sistemaOriginal.numeroPedido === sistemaAtualizado.numeroPedido &&
                      sistemaOriginal.dataExpiracao === sistemaAtualizado.dataExpiracao &&
                      sistemaOriginal.dataCancelamento === sistemaAtualizado.dataCancelamento &&
                      sistemaOriginal.situacaoCadastro === sistemaAtualizado.situacaoCadastro &&
                      // Compara os valores booleanos
                      ((sistemaOriginal.acessoSuporte === true) === (sistemaAtualizado.acessoSuporte === true)) &&
                      JSON.stringify(sistemaOriginal.limites) === JSON.stringify(sistemaAtualizado.limites)
                    );
                    
                    if (foiModificado) {
                      // Sempre atualiza na lista de modificados, garantindo que a versão mais recente seja salva
                      setSistemasModificados(prev => {
                        const idx = prev.findIndex(s => s.id === sistemaAtualizado.id);
                        if (idx >= 0) {
                          // Atualiza se já existe
                          const novos = [...prev];
                          novos[idx] = sistemaAtualizado;
                          return novos;
                        } else {
                          // Adiciona se não existe
                          return [...prev, sistemaAtualizado];
                        }
                      });
                    } else {
                      // Se não foi modificado em relação ao original, remove da lista de modificados
                      setSistemasModificados(prev => 
                        prev.filter(s => s.id !== sistemaAtualizado.id)
                      );
                    }
                  } else if (!isEdit || licencaEditando.id === 0) {
                    // Para sistemas novos ou modo criação, sempre adiciona/atualiza na lista de modificados
                    setSistemasModificados(prev => {
                      const idx = prev.findIndex(s => s.id === sistemaAtualizado.id);
                      if (idx >= 0) {
                        // Atualiza se já existe
                        const novos = [...prev];
                        novos[idx] = sistemaAtualizado;
                        return novos;
                      } else {
                        // Adiciona se não existe
                        return [...prev, sistemaAtualizado];
                      }
                    });
                  }
                } else {
                  // Sistema novo, sempre é marcado como modificado
                  const novaLicenca = criarNovaLicenca(dados, sistemaSelecionado);
                  setSistemas(prev => [...prev, novaLicenca]);
                  setSistemasModificados(prev => [...prev, novaLicenca]);
                }
                
                setMostrarModalSistemas(false);
                setEtapaModal('listar');
                setAlturaEtapa(2);
                setLicencaEditando(null);
                // Remove licencaId da URL ao finalizar
                if (licencaId) {
                  const params = new URLSearchParams(location.search);
                  params.delete('licencaId');
                  navigate(
                    { pathname: location.pathname, search: params.toString() },
                    { replace: true }
                  );
                }
              }}
            />
          )}
        </ModalSistemas>
      </div>
    );
}
 
export default CadastroCliente;